import {FlowEdge, FlowNode, Tree, TreeNode} from './types';

export function buildNodesTree(nodes: FlowNode[], edges: FlowEdge[]): Tree {
  // Find start flownode
  const startNode = nodes.find(node => node.type === 'start');
  if (!startNode) return {root: null, orphanNodes: nodes};

  // Keep track of nodes that are part of the tree
  const nodesInTree = new Set<string>();

  // Recursive function to build tree
  function buildSubtree(currentNode: FlowNode, parentNode?: TreeNode): TreeNode {
    nodesInTree.add(currentNode.id);
    const treeNode: TreeNode = {
      node: currentNode,
      children: [],
      parents: [parentNode as TreeNode],
    };

    const children = edges
      .filter(edge => edge.source === currentNode.id)
      .map(edge => {
        const childNode = nodes.find(node => node.id === edge.target);
        return childNode ? buildSubtree(childNode, treeNode) : null;
      })
      .filter((child): child is TreeNode => child !== null);

    // assign previous sibling for each child
    // for (let i = 1; i < children.length; i++) {
    //   children[i].previous_sibling = children[i - 1];
    // }

    treeNode.children = children;

    return treeNode;
  }

  const root_tree_node = buildSubtree(startNode);
  const orphanNodes = nodes.filter(node => !nodesInTree.has(node.id));
  // Connect orphan nodes to the root
  orphanNodes.forEach(orphanNode => {
    // Create a direct edge from root to this orphan node
    const orphanTreeNode = buildSubtree(orphanNode, root_tree_node);
    // Add the orphan node as a child of root
    root_tree_node.children.push(orphanTreeNode);
    // Mark it as no longer orphaned
    nodesInTree.add(orphanNode.id);
  });

  return {root: root_tree_node, orphanNodes};
}

export function flattenTree(tree: Tree): TreeNode[] {
  const flattened: TreeNode[] = [];
  function flatten(node: TreeNode) {
    flattened.push(node);
    node.children.forEach(flatten);
  }
  if (tree.root) flatten(tree.root);
  return flattened;
}
